import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import {getLocalStorage} from '@/Utils/CommonUtils';

export default function useBulkImportPgn(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  return useMutation(
    async ({gameId, file}: {gameId: string; file: File}) => {
      const token = await getLocalStorage('access_token');
      const formData = new FormData();
      formData.append('pgn_file', file);
      const options = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      };
      const response = await ChessRestClient.post(
        `learning/study_games/${gameId}/bulk_import_pgn/`,
        formData,
        options,
      );
      return response.data;
    },
    {
      onSuccess: data => {
        handleOnSuccess?.(data);
      },
      onError: error => {
        handleOnError?.(error);
      },
    },
  );
}
